module.exports = __webpack_public_path__ + "static/product-placeholder-01-61cb47b61210b8760872b6d37bc8c92e.jpg";